import {$Values} from 'utility-types'

// https://github.com/thysultan/stylis.js#plugins
const STYLIS_CONTEXTS = {
  POST_PROCESS: -2,
  PREPARATION: -1,
  NEWLINE: 0,
  PROPERTY: 1,
  SELECTOR_BLOCK: 2,
  AT_RULE: 3
}

export type StylisContextType = $Values<typeof STYLIS_CONTEXTS>

export const STYLIS_PREPARATION_CONTEXT = STYLIS_CONTEXTS.PREPARATION
export const STYLIS_PROPERTY_CONTEXT = STYLIS_CONTEXTS.PROPERTY
